import { Components, Theme } from '@mui/material/styles';

const MuiList: Components<Theme>['MuiList'] = {
  styleOverrides: {
    padding: {
      paddingTop: 0,
    },
  },
};

export default MuiList;
